import { convertToQueryString } from 'app/shared/functions';
import { HttpClient } from 'app/library/client';
import { IListFilter, ResponseBase, ResponseContentBase, ResponseListBase } from "app/shared";
import { ArtistRoleEntity } from './types';
import { getEndpoint } from 'app/utils/service';

export class ArtistRoleService {

    /** It gets all ArtistRole. */
    async getArtistRoles(options: IListFilter): Promise<ResponseBase<ResponseListBase<ArtistRoleEntity[]>>> {
        return HttpClient.getClient().get(getEndpoint('/artist-role/search') + `?${convertToQueryString(options)}`);
    }

    /** It get spesific ArtistRole by ArtistRole id */
    async getArtistRole(id: string, language: string): Promise<ResponseBase<ResponseContentBase<ArtistRoleEntity>>> {
        return HttpClient.getClient().get(getEndpoint('/artist-role/') + id + `?language=${language || "en"}`);
    }

    /** It creates ArtistRole by request */
    async createArtistRole(request: ArtistRoleEntity): Promise<ResponseBase<ResponseContentBase<ArtistRoleEntity>>> {
        return HttpClient.getClient().post(getEndpoint('/artist-role/'), request);
    }

    /** It updates spesific ArtistRole by id */
    async updateArtistRole(request: ArtistRoleEntity): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().patch(getEndpoint('/artist-role/') + request.id, request);
    }

    /** It deletes spesific ArtistRole by id */
    async deleteArtistRole(id: string): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().delete(getEndpoint('/artist-role/') + id);
    }
}
